export default __webpack_public_path__ + "static/media/trophy.f93a4201.png";